/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const coolingHVACEnumsAffectedRedundancyLevelOptionEnum = {
    NPlus1: 'NPlus1',
    V2N: 'V2N',
    SinglePointOfFailure: 'SinglePointOfFailure',
    Other: 'Other',
} as const;

export type CoolingHVACEnumsAffectedRedundancyLevelOptionEnumKey =
    (typeof coolingHVACEnumsAffectedRedundancyLevelOptionEnum)[keyof typeof coolingHVACEnumsAffectedRedundancyLevelOptionEnum];

export type CoolingHVACEnumsAffectedRedundancyLevelOption = CoolingHVACEnumsAffectedRedundancyLevelOptionEnumKey;
